// Scroll-position + "return to the photo you were viewing" memory.
//
// TimelineGrid unmounts whenever the user opens /asset/$id (the route
// swaps the page component under AppLayout), and react-window starts
// back at offset 0 on remount. These maps are module-level on purpose:
// they live for the SPA session, survive route changes, and reset on a
// full reload — exactly the lifetime back-navigation restoration wants.

const scrollOffsets = new Map<string, number>();

export function saveScrollOffset(key: string, offset: number): void {
  scrollOffsets.set(key, offset);
}

export function getScrollOffset(key: string): number {
  return scrollOffsets.get(key) ?? 0;
}

// One-shot "last viewed asset" — set by the lightbox on every asset it
// shows, consumed by the next grid mount. When the user arrows through
// many photos before going back, the saved scroll offset still points at
// where they *entered* the lightbox; this lets the grid bring the photo
// they *left* on into view instead. Cleared on consume so later grid
// visits don't keep jumping.

let lastViewedAssetID: string | null = null;

export function rememberViewedAsset(id: string): void {
  lastViewedAssetID = id;
}

export function consumeViewedAsset(): string | null {
  const id = lastViewedAssetID;
  lastViewedAssetID = null;
  return id;
}
